import { render } from "./FlatWindowRender.vue?vue&type=template&id=5a01703e&scoped=true"
import script from "./FlatWindowRender.vue?vue&type=script&lang=js"
export * from "./FlatWindowRender.vue?vue&type=script&lang=js"

import "./FlatWindowRender.vue?vue&type=style&index=0&id=5a01703e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a01703e"]])

export default __exports__